import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1C4.14008 1 1 4.14008 1 8C1 11.8599 4.14008 15 8 15C11.8599 15 15 11.8599 15 8C15 4.14008 11.8599 1 8 1ZM8 13.8333C4.7835 13.8333 2.16667 11.2165 2.16667 8C2.16667 4.7835 4.7835 2.16667 8 2.16667C11.2165 2.16667 13.8333 4.7835 13.8333 8C13.8333 11.2165 11.2165 13.8333 8 13.8333ZM10.3333 9.16667C10.3333 10.1315 9.54817 10.9167 8.58333 10.9167V11.5C8.58333 11.8226 8.32258 12.0833 8 12.0833C7.67742 12.0833 7.41667 11.8226 7.41667 11.5V10.9167H7.26033C6.63792 10.9167 6.05692 10.5818 5.74483 10.0422C5.58325 9.76283 5.67892 9.40642 5.95717 9.24542C6.23658 9.08267 6.59358 9.1795 6.754 9.45775C6.85842 9.63858 7.05208 9.75 7.25975 9.75H8.58275C8.90475 9.75 9.16608 9.48867 9.16608 9.16667C9.16608 8.94617 9.008 8.7595 8.79042 8.72333L7.0165 8.42758C6.23367 8.2975 5.66608 7.62667 5.66608 6.83333C5.66608 5.8685 6.45125 5.08333 7.41608 5.08333V4.5C7.41608 4.178 7.67683 3.91667 7.99942 3.91667C8.322 3.91667 8.58275 4.178 8.58275 4.5V5.08333H8.73908C9.3615 5.08333 9.9425 5.41875 10.2546 5.95833C10.4162 6.23717 10.3205 6.59358 10.0422 6.75517C9.76225 6.91675 9.40583 6.82108 9.24542 6.54225C9.141 6.362 8.94733 6.25058 8.73967 6.25058H7.41667C7.09467 6.25058 6.83333 6.5125 6.83333 6.83392C6.83333 7.05442 6.99142 7.24108 7.209 7.27725L8.98292 7.573C9.76575 7.70308 10.3333 8.37392 10.3333 9.16725V9.16667Z"
      fill="#151718"
    />
  </svg>
);

const IconJobCosting = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default IconJobCosting;
